/** Pembersih artefak scraping vendor pada field journalist (mis. "1 jam lalu", "https://situs, Nama"). */
export function cleanJournalist(v?: string | null): string {
  if (!v) return "";
  let s = String(v).trim();
  if (/^\d+\s*(detik|menit|jam|hari|minggu|bulan)\s+(yang\s+)?lalu$/i.test(s)) return "";
  // "https://situs.com/, Nama" → "Nama"
  s = s.replace(/https?:\/\/\S+[,\s]*/gi, "").replace(/^[,\s|-]+/, "").trim();
  if (/^https?:\/\//i.test(s) || s === "") return "";
  return s;
}
